import React from 'react';
import { Button, Box } from '@mui/material';

interface AppButtonProps {
  text: string;
  onClick: () => void;
  width?: number | string;
  height?: number | string;
  color?: string;
  disabled?: boolean;
  isWhite?: boolean;
  textStyle?: React.CSSProperties;
  sx?: object;
}

const ApplicationButton: React.FC<AppButtonProps> = ({
  text,
  onClick,
  width = 350,
  height = 40,
  color = '#0b60b0',
  disabled = false,
  isWhite = false,
  textStyle = {},
  sx = {},
}) => {
  return (
    <Box
      sx={{
        width,
        height,
        borderRadius: '4px',
        position: 'relative',
        display: 'flex',
        filter: disabled ? 'none' : 'drop-shadow(0px 4px 4px rgba(0,0,0,0.4))',
        border: isWhite ? '1px solid #0b60b0' : 'none',
        ...sx,
      }}
    >
      <Button
        fullWidth
        disabled={disabled}
        onClick={onClick}
        variant='contained'
        sx={{
          width: '100%',
          height: '100%',
          borderRadius: '4px',
          backgroundColor: isWhite ? '#FFFFFF' : color,
          '&:disabled': {
            backgroundColor: '#7F7F7F',
          },
        }}
      >
        <span
          style={{
            color: !disabled ? (isWhite ? '#0b60b0' : '#FFFFFF') : '#FFFFFF',
            fontWeight: 'bold',
            textAlign: 'center',
            ...textStyle,
          }}
        >
          {text}
        </span>
      </Button>
    </Box>
  );
};

export default ApplicationButton;
